import AdminOperationsScreen from "../../src/features/arrangements/screens/AdminOperationsScreen";

export default function EventsScreen() {
  return <AdminOperationsScreen screenIdOverride="event-calendar" />;
}
